// src/components/offline/OfflineIndicator.js
import { Wifi, WifiOff, Clock } from 'lucide-react';
import { useOfflineStorage } from '../../hooks/useOfflineStorage';

const OfflineIndicator = () => {
  const { 
    isOnline, 
    pendingSyncCount, 
    syncPendingOrders,
    getOfflineCustomerOperations,
    syncOfflineCustomers
  } = useOfflineStorage();

  const pendingCustomerOperations = getOfflineCustomerOperations().length;
  const totalPendingOperations = pendingSyncCount + pendingCustomerOperations;

  if (isOnline && totalPendingOperations === 0) {
    return (
      <div className="flex items-center space-x-2 px-3 py-2 bg-green-50 text-green-700 rounded-lg border border-green-200">
        <Wifi className="w-4 h-4" />
        <span className="text-sm font-medium">Online</span>
      </div>
    );
  }

  if (!isOnline) {
    return (
      <div className="flex items-center space-x-2 px-3 py-2 bg-orange-50 text-orange-700 rounded-lg border border-orange-200">
        <WifiOff className="w-4 h-4" />
        <span className="text-sm font-medium">Modalità Offline</span>
      </div>
    );
  }

  if (totalPendingOperations > 0) {
    const handleSyncAll = async () => {
      try {
        if (pendingSyncCount > 0) {
          await syncPendingOrders();
        }
        if (pendingCustomerOperations > 0) {
          await syncOfflineCustomers();
        }
      } catch (error) {
        console.error('Errore sincronizzazione:', error);
      }
    };

    return (
      <div className="flex items-center space-x-2 px-3 py-2 bg-blue-50 text-blue-700 rounded-lg border border-blue-200">
        <Clock className="w-4 h-4" />
        <span className="text-sm font-medium">
          {pendingSyncCount > 0 && `${pendingSyncCount} ordini`}
          {pendingSyncCount > 0 && pendingCustomerOperations > 0 && ', '}
          {pendingCustomerOperations > 0 && `${pendingCustomerOperations} clienti`}
          {' da sincronizzare'}
        </span>
        <button
          onClick={handleSyncAll}
          className="ml-2 px-2 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700 transition-colors"
        >
          Sincronizza
        </button>
      </div>
    );
  }

  return null;
};

export default OfflineIndicator;